import ky from 'ky';

export type Fetcher = ReturnType<typeof createFetcher>;

export function createFetcher() {
  const apiEndpoint = import.meta.env.VITE_API_ENDPOINT + '/flex/';

  return ky.extend({
    headers: {
      'content-type': 'application/json',
    },
    prefixUrl: apiEndpoint,
    retry: 2,
    timeout: 15000,
    throwHttpErrors: false,
  });
}
